/* jshint esversion: 6 */
/* eslint-disable no-unused-vars */
import 'babel-polyfill';

import Vue from 'vue';
import App from './App';

import router from './router';
import store from './store';
import cordova from './cordova';

// import variables from './styles/variables';
import css from './styles/main.css';

import bus from './services/bus-event';

require('moment/locale/es');

require('./components');

if (!process.env.CORDOVA) {
    console.log('***********************************************');
    console.log('Not running in cordova');
    console.log('***********************************************');
    bus.emit('device-register');
    store.dispatch('init');
}

const PUBLIC_ROUTE_NAMES = [
    'login',
    'register',
    'reset-password',
    'reset-password-confirm',
    'terms',
    'upgrade-chofer',
    'select-promotion',
    'cotizacion'
];

bus.on('system-ready', () => {
    let app = new Vue({
        el: '#app',
        router,
        store,
        template: '<App/>',
        components: { App }
    });
    if (store.getters['auth/checkLogin']) {
        router.push({name: 'home'});
    } else {
        const name = router.currentRoute && router.currentRoute.name;
        if (name && PUBLIC_ROUTE_NAMES.indexOf(name) !== -1) {
            return;
        }
        router.push({name: 'login'});
    }
});
/* eslint-enable no-unused-vars */
/*
replace const with var y polyfill URLSearchParams

-------------------------------

project.properties

target=android-26
android.library.reference.1=CordovaLib
cordova.system.library.1=com.android.support:support-v4:26+
cordova.system.library.3=com.android.support:support-v4:26.0.0+
cordova.gradle.include.1=cordova-plugin-crosswalk-webview/motoride-xwalk.gradle
cordova.gradle.include.2=cordova-plugin-mauron85-background-geolocation/motoride-logtofile.gradle
cordova.system.library.2=com.google.android.gms:play-services-location:11.0.1
cordova.system.library.6=me.leolin:ShortcutBadger:1.1.17@aar
cordova.system.library.7=com.google.firebase:firebase-messaging:11.0.1
cordova.gradle.include.3=phonegap-plugin-push/motoride-push.gradle

-------------------------------

buid-extra.gradle

configurations.all {
  resolutionStrategy.force 'com.android.support:support-v4:26.0.0'
}
*/



// WEBPACK FOOTER //
// ./src/main.js